module.exports = __webpack_public_path__ + "img/img_unpublish.09ddaadd.png";